export default "__VITE_ASSET__BX_em5G2__"